<template>
  <div id="app" class="app">
    <router-view/>
    <app-snackbar></app-snackbar> 
  </div>
</template>

<script>
import AppEvents   from '@/app/event'
import AppSnackbar from '@/app/components/admin/app/Snackbar'
import User        from '@/utils/models/User'
export default {
  name: 'app',
  components: {AppSnackbar},
  created () {
    window.getApp = this;
    
    AppEvents.forEach(item => {
        this.$on(item.name, item.callback);
    });                

    this.$store.dispatch('GET_DICTIONS');
  }, 
  mounted(){
    //setTimeout(()=>{console.log(this.$store.getters.DICTIONS);}, 3000)    
  },
  watch:{
    $route (to/*, from*/){
      if(!to.meta.guest){
        User.isLogin();
      }                     
    },
  }    
}
</script>
<style>
.swal2-container {font-family: 'Roboto', sans-serif;}
.ramping td, .ramping th {padding: 0 5px;}
</style>
